import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getbookSameDayList = createAsyncThunk(
  "bookSameDayList/getbookSameDayList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/book-same-day`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const bookSameDaySlice = createSlice({
  name: "bookSameDayList",
  initialState: {
    loading: false,
    bookSameDayData: null,
    error: null,
  },
  reducers: {
    ResetbBookSameDataState: (state) => {
      state.loading = false;
      state.bookSameDayData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getbookSameDayList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getbookSameDayList.fulfilled, (state, action) => {
        state.loading = false;
        state.bookSameDayData = action.payload;
      })
      .addCase(getbookSameDayList.rejected, (state, action) => {
        state.loading = false;
        state.bookSameDayData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetbBookSameDataState } = bookSameDaySlice.actions;
export default bookSameDaySlice.reducer;
